import React from 'react';
import { ButtonArrow, Container, CounterWrapper, Link, List, ListItem } from './Pagination.styles';
import { ArrowType, ItemType } from './Pagination.props';
import { itemsPagination } from './paginationNumGenerator';
import Icon from '../Icon';

type Props = {
    findPageURL?: (page: string) => string;
    paginate: {
        current_page: number;
        pages: number;
        items: number;
        next_page?: number;
    };
    onChangePage: (page: string | number) => void;
};

const Pagination = ({ paginate, findPageURL = null, onChangePage }: Props) => {
    const currentPage = paginate?.current_page;
    const maxPages = paginate?.pages;
    const sidesNum = 3;
    const maxNumberPagesShow = sidesNum * 2;
    const greaterMax = maxPages > maxNumberPagesShow;
    const showInitialPage = currentPage > maxPages / 2 && greaterMax;
    const showFinalPage = currentPage <= maxPages / 2 && greaterMax;
    const isMaxPageNum = maxPages <= maxNumberPagesShow;
    const itemsNum = itemsPagination({ currentPage, maxPages, sidesNum, showInitialPage, showFinalPage, isMaxPageNum, maxNumberPagesShow });

    const Arrow = ({ icon, numPage, direction }: ArrowType) => {
        const newUrl = findPageURL && findPageURL(numPage.toString());
        return (
            <ListItem className={`arrow ${direction}`} data-testid={`arrow-${direction}`} data-gtm={`arrow ${direction}`}>
                <ButtonArrow>
                    <Link href={newUrl} onClick={() => onChangePage(numPage)} className="arrow" title={`page-${numPage}`} aria-label={`page-${numPage}`}>
                        <Icon disableFill icon={icon} size={15} />
                    </Link>
                </ButtonArrow>
            </ListItem>
        );
    };

    const ItemSeparator = () => (
        <ListItem className="separator" data-testid="separator">
            <Link>...</Link>
        </ListItem>
    );
    const Item = ({ item }: ItemType) => {
        const newUrl = findPageURL && findPageURL(item.toString());
        const isActive = item === currentPage;
        return (
            <ListItem data-gtm={`page number ${item}`}>
                {isActive ? (
                    <Link className={`${isActive && 'active'}`}>{item}</Link>
                ) : (
                    <Link href={newUrl} onClick={() => onChangePage(item)} aria-label={`page-${item}`} title={`page-${item}`}>
                        {item}
                    </Link>
                )}
            </ListItem>
        );
    };
    return (
        <>
            {paginate?.items > 0 && (
                <Container data-testid="container-pagination" data-gtm="container pagination">
                    <List aria-label="items-pagination">
                        {currentPage > 1 && <Arrow icon="pcom-icon-chevron-left" direction="left" numPage={currentPage - 1} />}
                        {showInitialPage && (
                            <>
                                <Item item={1} />
                                <ItemSeparator />
                            </>
                        )}
                        {itemsNum.map((item) => (
                            <Item key={item} item={item} />
                        ))}
                        {showFinalPage && (
                            <>
                                <ItemSeparator />
                                <Item item={maxPages} />
                            </>
                        )}
                        {currentPage < maxPages && <Arrow icon="pcom-icon-chevron-right" direction="right" numPage={currentPage + 1} />}
                    </List>
                    <CounterWrapper data-testid="counter-wrapper" data-gtm="counter pagination">
                        Página {currentPage} de {maxPages} - <b>{paginate?.items?.toLocaleString('es-MX')}</b> resultados
                    </CounterWrapper>
                </Container>
            )}
        </>
    );
};

export default Pagination;
